// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3S0Ed","head":"Table_head__bG8Jh","col":"Table_col__IM-cT"};